module.exports = __webpack_public_path__ + "media/images/icons/icon-explore-near-me-37e9f5e36c3359e94629c09292957cc5.svg";